import React from "react";
import "./CustomInput.scss"
import user from "../../assets/profile-2.svg"
import mail from "../../assets/mail.svg"
import address from "../../assets/location-black.svg"
import lock from "../../assets/lock.svg";
import search from "../../assets/search.svg";



const CustomInput = ({ label, icon, value, onChange, placeholder, required, error, errorText, disable, type = "text" }) => {
    const getIcons = () => {
        const icons = {
            user: user,
            email: mail,
            address: address,
            lock: lock,
            search: search
        };

        return icons[icon] || user;
    };

    return (
        <div className="CustomInput">
            <div className="input-label">
                {required && <span className="input-req">* </span>}
                {label}
            </div>
            <div className={`CustomInput-container ${error ? "error" : disable ? "disable" : ""}`}>
                {icon && <img className="CustomInput-container-icon" alt="" src={getIcons()} />}
                <input
                    className="CustomInput-container-input"
                    value={value}
                    onChange={onChange}
                    type={type}
                    placeholder={placeholder}
                    disabled={disable ?? false}
                />
            </div>
            {
                errorText !== "" && < div className="input-error-text">
                    {errorText}
                </div>
            }
        </div >
    )
}
export default CustomInput